import React from "react";
import {MainCP}  from "../../Components/plebiscito-salida/MainCP"

const ViewPlebiscito: React.FC = () => <MainCP/>

export default ViewPlebiscito;